<template>
    <!-- <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>

    </ion-toolbar> -->

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="d-flex flex-col flex-1 justify-center align-items-center">
                <div class="success-icon">
                    <svg width="309" height="309" viewBox="0 0 309 309" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="154.5" cy="154.5" r="153.25" stroke="#009F98" stroke-width="1.5"
                            stroke-dasharray="3 5" />
                        <circle cx="154.5" cy="154.5" r="137.5" fill="white" />
                        <path
                            d="M223.733 140.046L217.067 134.952C217.933 131.869 218.667 129.256 219.333 126.977C222 117.996 223.467 113.037 219.8 107.944C216.133 102.85 211.133 102.649 201.667 102.381H193.4C192.267 99.4321 191.4 96.8184 190.6 94.6067C187.533 85.7603 185.8 81.203 179.8 78.9243C173.8 76.6457 169.6 79.8626 161.867 85.2241L155.2 89.8484L148.533 85.3581C141.667 79.9296 136.6 76.5787 130.533 78.5892C124.467 80.5998 122.867 85.2911 119.733 94.2046C118.933 96.4163 118 99.03 116.933 102.046L108.333 102.314C99 102.314 93.8667 102.649 90.2 107.742C86.5333 112.836 88.3333 117.795 90.8667 126.843C91.5333 129.121 92.3333 131.735 93.1333 134.818L86.4667 139.912C79.2 145.541 75 148.691 75 155.058C75 161.425 79.0667 164.507 86.4667 170.204L93.1333 175.298C92.3333 178.38 91.5333 180.994 90.8667 183.273C88.2 192.253 86.7333 197.213 90.4 202.306C94.0667 207.4 99.2667 207.534 108.533 207.802H116.733C117.867 210.751 118.733 213.364 119.533 215.576C122.667 224.422 124.333 228.98 130.333 231.258C136.333 233.537 140.533 230.32 148.267 224.959L154.933 220.334L161.6 224.824C165.712 228.443 170.787 230.772 176.2 231.526C177.402 231.514 178.595 231.31 179.733 230.923C185.733 228.98 187.4 224.221 190.533 215.308C191.333 213.096 192.2 210.482 193.333 207.534H201.6C210.933 207.534 216.067 207.199 219.733 202.038C223.4 196.878 222 191.985 219.333 183.005C218.667 180.726 217.867 178.112 217.067 175.029L223.733 169.936C231.067 164.641 235 161.76 235 155.058C235 148.356 231.067 145.742 223.733 140.046Z"
                            fill="#009F98" />
                        <path
                            d="M144.133 190.309C143.232 190.271 142.348 190.05 141.534 189.658C140.721 189.266 139.994 188.713 139.4 188.031L119.733 165.981C118.557 164.648 117.957 162.9 118.063 161.122C118.169 159.343 118.974 157.68 120.3 156.498C121.626 155.316 123.365 154.712 125.134 154.819C126.903 154.926 128.557 155.735 129.733 157.068L144.533 173.89L186.733 132.606C187.341 131.914 188.085 131.356 188.917 130.967C189.749 130.578 190.653 130.366 191.571 130.344C192.488 130.322 193.401 130.491 194.251 130.84C195.101 131.189 195.87 131.711 196.509 132.372C197.149 133.034 197.646 133.822 197.969 134.686C198.292 135.55 198.434 136.471 198.387 137.393C198.339 138.315 198.102 139.216 197.691 140.042C197.281 140.867 196.705 141.599 196 142.19L148.8 188.567C147.526 189.732 145.854 190.356 144.133 190.309Z"
                            fill="white" />
                    </svg>

                </div>
                <div class="success-title">
                    Congratulations!
                </div>
                <p class="success-subtext">
                    We'll let the pharmacy know you accepted the shift.
                </p>
            </div>
            <div class="button-group w-full">
                <el-button class="submit w-full" type="primary" data-testid="directions-56" @click="completeButton()">
                    Home
                </el-button>
            </div>

        </div>
        <div class="bg-circle-gradient"></div>
    </div>
</template>


<script>

import {
    addIcons
} from 'ionicons'
import {
    arrowBackOutline
} from 'ionicons/icons'
addIcons({
    'arrow-back-outline': arrowBackOutline
})

import {
    useRouter,
} from 'vue-router'
export default {
    components: {
    },
    directives: {

    },
    setup() {
        const $router = useRouter()

        const completeButton = () => {
            $router.push({
                name: 'search'
            })
        };


        return {
            completeButton
        }
    },
}
</script>